var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("a-icon", { staticClass: "a-icon", attrs: { type: "plus-circle" } }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text",
          },
        ],
        staticClass: "ant-input",
        attrs: { disabled: _vm.disabled, type: "text", readonly: "" },
        domProps: { value: _vm.text },
        on: {
          click: _vm.openModal,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.text = $event.target.value
          },
        },
      }),
      _c(
        "a-modal",
        {
          attrs: {
            forceRender: "",
            title: _vm.title,
            width: 800,
            "ok-text": "确认",
            "cancel-text": "取消",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleClose },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [_vm._t("childTable")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }